<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <h2 class="mb-4">
                {{ $t("cookiePolicy") }}
            </h2>

            <p>
                {{ $t("cookiePolicyContent.line1") }}
            </p>

            <h5 class="mt-5">
              {{ $t("cookiePolicyContent.line2") }}
            </h5>

            <p>
              {{ $t("cookiePolicyContent.line3") }}
            </p>

            <h5 class="mt-5">
              {{ $t("cookiePolicyContent.line4") }}

            </h5>

            <p>
                {{ $t("cookiePolicyContent.line5") }}
            </p>

            <h5 class="mt-5">
                {{ $t("cookiePolicyContent.line6") }}
            </h5>

            <p>
                {{ $t("cookiePolicyContent.line7") }}
            </p>

            <h5 class="mt-5">
                {{ $t("cookiePolicyContent.line8") }}
            </h5>

            <p>
                {{ $t("cookiePolicyContent.line9") }}
            </p>

            <p>
               {{ $t("cookiePolicyContent.line10") }}
            </p>

            <p>
                {{ $t("cookiePolicyContent.line11") }}
            </p>

            <p>
                {{ $t("cookiePolicyContent.line12") }}
            </p>

            <p>
                {{ $t("cookiePolicyContent.line13") }}
            </p>

            <p>
                {{ $t("cookiePolicyContent.line14") }}
            </p>

            <p>
                {{ $t("cookiePolicyContent.line15") }}
            </p>

            <h5 class="mt-5">
              {{ $t("cookiePolicyContent.line16") }}
            </h5>

            <p>
                {{ $t("cookiePolicyContent.line17") }}
            </p>

            <p>
                {{ $t("cookiePolicyContent.line18") }}
            </p>

            <p>
                {{ $t("cookiePolicyContent.line19") }}
            </p>

            <p>
               {{ $t("cookiePolicyContent.line20") }}
            </p>

            <p>
                {{ $t("cookiePolicyContent.line21") }}
            </p>

            <p>
                {{ $t("cookiePolicyContent.line22") }}
            </p>

            <p>
                {{ $t("cookiePolicyContent.line23") }}
            </p>

            <p>
                {{ $t("cookiePolicyContent.line24") }}
            </p>

            <h5 class="mt-5">
                {{ $t("cookiePolicyContent.line25") }}
            </h5>

            <p>
                {{ $t("cookiePolicyContent.line26") }}
            </p>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";

export default {
    name: "CookiePolicy",

    components: {
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - ${this.$t("cookiePolicy")}`,
        };
    },
};
</script>
